import React from "react";
import styles from "./home.module.css";
import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const baseURL = `${process.env.REACT_APP_API_URL}`

const Home = () => {
  const [houseManagers, setHouseManagers] = useState([]);
  const [error, setError] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 2;
  const navigate = useNavigate();

  useEffect (() => {
    const fetchHouseManagers = async () => {
      try {
        const response = await axios.get(`${baseURL}/profiles/housemanagers/`);
        setHouseManagers(response.data);

        response.data.forEach(manager => fetchReviews(manager.id));
      } catch (error) {
        console.error("Error fetching house managers:", error.response?.data || error.message);
        setError('Failed to fetch house managers. Please try again later')
      }
    }
    const fetchReviews = async (houseManagerId) => {
      try {
        const response = await axios.get(`${baseURL}/profiles/reviews-aside/${houseManagerId}/`);
        setReviews((prevReviews) => ({
          ...prevReviews, [houseManagerId]: response.data
        }))
      } catch (error) {
        console.error('Error fetching reviews:', error.response?.data || error.message);
      }
    }

    fetchHouseManagers();
  }, [])

  const indexOfLastManager = currentPage * itemsPerPage;
  const indexOfFirstManager = indexOfLastManager - itemsPerPage;
  const currentManagers = houseManagers.slice(indexOfFirstManager, indexOfLastManager)


  return (
    <div className={styles.landingPage}>
      <div className={styles.mainContent}>
        {/* Hero Section */}
        <section className={styles.heroSection}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>Find Your Perfect Match</h1>
            <p className={styles.heroSubtitle}>
              Connecting trusted house managers with caring employers.
            </p>
            <button className={styles.heroButton}>Get Started</button>
          </div>
          <div className={styles.heroImage}>
            <img
              src="/jane.jpg"
              alt="House manager helping with chores"
              className={styles.image}
            />
          </div>
        </section>

        {/* Features Section */}
        <section className={styles.featuresSection}>
          <h2 className={styles.sectionTitle}>Why Choose MaidMatch?</h2>
          <div className={styles.featuresGrid}>
            <div className={styles.feature}>
              <i className="fas fa-user-check" style={{ color: "#007bff" }}></i>
              <h3>Verified Profiles</h3>
              <p>All profiles are screened and verified for trust and safety.</p>
            </div>
            <div className={styles.feature}>
              <i className="fas fa-star" style={{ color: "#f39c12" }}></i>
              <h3>Top Ratings</h3>
              <p>Find highly-rated house managers with real employer reviews.</p>
            </div>
            <div className={styles.feature}>
              <i className="fas fa-handshake" style={{ color: "#28a745" }}></i>
              <h3>Seamless Matching</h3>
              <p>Easily connect with house managers that fit your needs.</p>
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className={styles.ctaSection}>
          <h2>Ready to Find Your Match?</h2>
          <p>
            Join thousands of employers and house managers using MaidMatch
            today!
          </p>
          <button className={styles.ctaButton} onClick={() => navigate("/register")}>
            Join Now
          </button>
        </section>
      </div>

      {/* Sidebar */}
      <aside className={styles.sidebar}>
        <h2 className={styles.sidebarTitle}>Featured House Managers</h2>
        {error && <p className={styles.error}>{error}</p>}
        {houseManagers.length === 0 && !error && <p className={styles.loadingContent}>
              <FontAwesomeIcon icon={faSpinner} spin size="3x" className={styles.spinner} />
              <span className={styles.loadingText}>Loading...</span>
          </p>}
        {currentManagers.map((manager) => (
          <div key={manager.id} className={styles.managerCard}>
            <Link to= {`/profile/house_manager/${manager.id}`}>
              <img
                src={`${baseURL}${manager.image}`}
                alt={`${manager.name}'s profile`}
                className={styles.managerImage}
              />
            
            </Link>
              <div className={styles.managerDetails}>
                <Link to= {`/profile/house_manager/${manager.id}`}>
                  <h3>{manager.first_name} {manager.last_name}</h3>
                </Link>
                
                <p>📍 {manager.location}</p>
                <p>⭐ {manager.rating.toFixed(1)} / 5.0</p>
                <p>💼 Experience: {manager.experience} Years</p>
                <h4>Reviews</h4>
                {reviews[manager.id] ? (
                  reviews[manager.id].length > 0 ? (
                    reviews[manager.id].map((review) => (
                      <div key={review.id}>
                        <Link
                            to={`/profile/employer/${review.reviewer_id}`}
                            key={review.id}
                            className={styles.resultCard}
                        >
                          <p><strong>{review.reviewer_username}</strong></p>
                        </Link>
                        <p>⭐ {review.rating.toFixed(1)}</p>
                        <p>📝 {review.comment}</p>
                      </div>
                    ))
                  ) : (
                    <p>No reviews yet.</p>
                  )
                ) : (
                  <p>Loading reviews...</p>
                )}
              </div>
          </div>
        ))}
        <div className={styles.pagination}>
          <button
            className={styles.pageButton}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            ◀ Previous
          </button>
          <span className={styles.pageNumber}>Page {currentPage}</span>
          <button 
            className={styles.pageButton}
            onClick={() => setCurrentPage((prev) => (prev * itemsPerPage <houseManagers.length ? prev + 1 : prev))}
            disabled={indexOfLastManager >= houseManagers.length}
          >
            Next ▶
          </button>
        </div>
      </aside>
    </div>
  );
};

export default Home;
